import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { safeLocalStorage } from "@/shared/lib/safeStorage";
export const useUserStore = create()(persist((set) => ({
    user: null,
    isAuthenticated: false,
    isLoading: true,
    accessToken: null,
    refreshToken: null,
    setUser: (user) => set({ user }),
    setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
    setLoading: (isLoading) => set({ isLoading }),
    setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
    login: (user, accessToken, refreshToken) => set({
        user,
        accessToken,
        refreshToken,
        isAuthenticated: true,
    }),
    logout: () => set({
        user: null,
        accessToken: null,
        refreshToken: null,
        isAuthenticated: false,
    }),
    updateUser: (userData) => set((state) => ({
        user: state.user ? { ...state.user, ...userData } : null,
    })),
}), {
    name: "user-storage",
    // iOS/WebView: localStorage может быть null — дефолтный persist падает
    // с «null is not an object (evaluating 'localStorage.getItem')».
    storage: createJSONStorage(() => safeLocalStorage),
    partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
    }),
}));
